const pgcetmcaAnalyticalReasoning = [
  {
    id: 56,
    question: "Ravi is Meena's brother. Suresh is Meena's father. Anita is Suresh's mother. How is Ravi related to Anita?",
    options: ["A. Grandson", "B. Son", "C. Nephew", "D. Grandfather"],
    answer: "A"
  },
  {
    id: 57,
    question: "In a certain code language, 'PLANT' is written as 'QMBOU'. How is 'GARDEN' written in that code?",
    options: ["A. HBSEFP", "B. FZQCDM", "C. HBSEFO", "D. GBSEFO"],
    answer: "C"
  },
  {
    id: 58,
    question: "Find the next number in the series: 4, 9, 19, 39, 79, ?",
    options: ["A. 169", "B. 149", "C. 159", "D. 158"],
    answer: "C"
  },
  {
    id: 59,
    question: `Statements: All pens are books. All books are tables.
      Conclusions:
      I. All pens are tables.
      II. Some tables are pens.`,
    options: ["A. Both conclusions I and II follow", "B. Only conclusion I follows", "C. Only conclusion II follows", "D. Neither I nor II follows"],
    answer: "A"
  },
  {
    id: 60,
    question: `A set of letters is arranged in order with some missing.
      a _ c d _ f g _ i
      Choose the correct order of the missing letters.`,
    options: ["A. a, e, h", "B. b, e, j", "C. b, e, h", "D. b, f, h"],
    answer: "C"
  },
  {
    id: 61,
    question: "Ramesh walks 5 km towards East, then turns left and walks 3 km, then turns left again and walks 5 km. How far is he from his starting point?",
    options: ["A. 5 km", "B. 3 km", "C. 8 km", "D. 13 km"],
    answer: "B"
  },
{
  id: 62,
  question: "Five years ago, a father was 4 times as old as his son. Ten years hence, the father will be twice as old as his son. What is the father's present age?",
  options: ["A. 35 years", "B. 40 years", "C. 50 years", "D. 45 years"],
  answer: "A"
},
  {
    id: 63,
    question: " In a class of 40 students, 18 play chess, 20 play carrom, and 6 play both games. How many students play neither chess nor carrom?",
    options: ["A. 10", "B. 6", "C. 8", "D. 4"],
    answer: "C"
  },
  {
    id: 64,
    question: `Five groups of letters are given. One of these groups is different from the other four. Find the odd one.
      BDFH, PRTV, JLNP, ACEG, MOQS`,
    options: ["A. JLNP", "B. BDFH", "C. PRTV", "D. ACEG"],
    answer: "D"
  },
  {
    id: 65,
    question: "If 26th January 2025 was a Sunday, then on which day of the week will 26th January 2040 fall?",
    options: ["A. Friday", "B. Thursday", "C. Wednesday", "D. Saturday"],
    answer: "B"
  },
  {
    id: 66,
    question: `Consider the following equations I and II.
    I: √(2 1/4) = 1 1/2
    II: 2√(1331) = 3 × 11√11`,
    options: ["A. I is incorrect, II is correct", "B. I and II are correct", "C. I is correct, II is incorrect", "D. I and II are incorrect"],
    answer: "C"
  },
  {
    id: 67,
    question: "If A ⊕ B means A and B are siblings, and A – B means A is older than B, then Meera ⊕ Kavya – Sohan means _____.",
    options: ["A. Kavya is older than Sohan", "B. Meera is older than Sohan", "C. Sohan is the eldest", "D. Meera is the youngest"],
    answer: "B"
  },
  {
    id: 68,
    question: "A figure consists of a circle attached to a square such that the circle is on top. If the figure is rotated 180° clockwise, where will the circle be?",
    options: ["A. Right", "B. Top", "C. Left", "D. Bottom"],
    answer: "D"
  },
  {
    id: 69,
    question: `The following bar chart shows the number of laptops sold by five stores (in hundreds): P-12, Q-18, R-15, S-9, T-6.
    What is the average number of laptops sold per store?`,
    options: ["A. 1500", "B. 1000", "C. 1200", "D. 1100"],
    answer: "C"
  },
  {
    id: 70,
    question: `Two positions of a dice are shown below:
    Position 1: top-1, front-2, right-3
    Position 2: top-1, front-6, right-5
    Which number is opposite to the face showing 2?`,
    options: ["A. 5", "B. 6", "C. 3", "D. 4"],
    answer: "B"
  }

];
 
export default pgcetmcaAnalyticalReasoning;
 